import { memo } from "react"
import { Typography } from "@mui/material"
import { MonetaryAmount } from "../../../../../../modules/currency/currencyTypes"
import { toDinero } from "../../../../../../modules/currency/currencyLib"
import { useMoney } from "../../../../../../modules/currency/useMoney"

type PackageCounterProps = {
    price?: MonetaryAmount
}
export const ProductAmount = memo(({ price }: PackageCounterProps) => {
    const moneyFactory = useMoney({})

    if (!price) return null

    return <Typography variant="body1">{moneyFactory.formatAsNumber(toDinero(price))}</Typography>
})
